import { Link, Navigate, useLocation } from 'react-router-dom';
import SEO from '../components/SEO';
import { legacyTarget } from '../data/legacyRedirects';

const POPULAR = [
  ['/services/land-surveying', 'Land Survey CAD Drafting'],
  ['/survey-cad-outsourcing', 'Survey CAD Outsourcing'],
  ['/services', 'All CAD Drafting Services'],
  ['/service-areas', 'Service Areas'],
  ['/get-quote', 'Get a Quote'],
];

export default function NotFound() {
  const { pathname, search } = useLocation();
  const target = legacyTarget(pathname);
  if (target && target !== pathname) return <Navigate to={`${target}${search}`} replace />;

  return (
    <section className="min-h-[60vh] bg-[#0A0A0A] text-white flex items-center" data-testid="not-found-page">
      <SEO title="Page Not Found" description="This page has moved or no longer exists. Browse land survey CAD drafting services, service areas or request a free quote from Land Drafters." path={pathname} noindex />
      <div className="container-custom py-20">
        <p className="text-primary text-xs font-bold uppercase tracking-widest mb-4">Error 404</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase mb-6">Page not found</h1>
        <p className="text-white/70 max-w-xl mb-8">The page you’re looking for has moved. Try one of these instead:</p>
        <h2 className="sr-only">Popular pages</h2>
        <ul className="flex flex-wrap gap-3">
          {POPULAR.map(([to, label]) => (
            <li key={to}><Link to={to} className="inline-block border border-white/20 px-4 py-2 text-sm hover:border-primary hover:text-primary transition-colors" data-testid={`not-found-link-${to.replace(/\//g, '-')}`}>{label}</Link></li>
          ))}
        </ul>
      </div>
    </section>
  );
}
